import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export default function FAQAccordion({ faqs = [] }) {
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full"
      data-testid="faq-accordion"
    >
      {faqs.map((faq, idx) => (
        <AccordionItem
          value={`faq-${idx}`}
          key={`faq-${idx}`}
          className="border-b border-soft-grey"
          data-testid={`faq-item-${idx}`}
        >
          <AccordionTrigger
            data-testid={`faq-trigger-${idx}`}
            className="text-left font-serif text-xl md:text-2xl text-navy hover:no-underline py-6"
          >
            {faq.q}
          </AccordionTrigger>
          <AccordionContent
            data-testid={`faq-content-${idx}`}
            className="text-charcoal/75 text-base md:text-[17px] leading-relaxed pr-4 pb-7 max-w-3xl"
          >
            {faq.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
